import { useEffect, useState, useCallback } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { hhmm, todayIE } from "@/lib/format";
import TimeEntries, { TIME_EDIT_ROLES } from "@/components/TimeEntries";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export default function MyTimeEntries({ customers, refreshKey }) {
  const { user } = useAuth();
  const [f, setF] = useState({ start: todayIE(), end: todayIE(), customer_id: "all" });
  const [rows, setRows] = useState([]);
  const load = useCallback(() => {
    const params = { mine: true, start: f.start || undefined, end: f.end || undefined };
    if (f.customer_id !== "all") params.customer_id = f.customer_id;
    api.get("/job-time", { params }).then((r) => setRows(r.data)).catch(() => {});
  }, [f]);
  useEffect(() => { load(); }, [load, refreshKey]);
  const total = rows.reduce((s, r) => s + r.minutes, 0);
  return (
    <div className="card-industrial p-5" data-testid="my-time-entries">
      <div className="flex items-center justify-between mb-3">
        <h3 className="font-heading font-bold uppercase tracking-wide text-sm">My Time Entries</h3>
        <span className="font-mono-num text-sm text-primary font-bold" data-testid="my-time-total">{hhmm(total)}</span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 mb-3">
        <div><Label className="text-[11px]">From</Label><Input type="date" value={f.start} onChange={(e) => setF({ ...f, start: e.target.value })} data-testid="my-time-from" /></div>
        <div><Label className="text-[11px]">To</Label><Input type="date" value={f.end} onChange={(e) => setF({ ...f, end: e.target.value })} data-testid="my-time-to" /></div>
        <div className="sm:col-span-2"><Label className="text-[11px]">Customer</Label>
          <Select value={f.customer_id} onValueChange={(v) => setF({ ...f, customer_id: v })}>
            <SelectTrigger data-testid="my-time-customer"><SelectValue /></SelectTrigger>
            <SelectContent><SelectItem value="all">All customers</SelectItem>{customers.map((c) => <SelectItem key={c.id} value={c.id}>{c.name}</SelectItem>)}</SelectContent>
          </Select></div>
      </div>
      {rows.length === 0 ? <p className="text-sm text-muted-foreground py-2">No time entries for these filters.</p>
        : <TimeEntries rows={rows} showUser={false} canEdit={TIME_EDIT_ROLES.includes(user.role)} onChanged={load} testid="my-time" />}
    </div>
  );
}
